var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5938 21.5469C11.7587 21.5469 12.7031 20.6025 12.7031 19.4375C12.7031 18.2725 11.7587 17.3281 10.5938 17.3281C9.42877 17.3281 8.48438 18.2725 8.48438 19.4375C8.48438 20.6025 9.42877 21.5469 10.5938 21.5469Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6719 21.5469C18.8369 21.5469 19.7812 20.6025 19.7812 19.4375C19.7812 18.2725 18.8369 17.3281 17.6719 17.3281C16.5069 17.3281 15.5625 18.2725 15.5625 19.4375C15.5625 20.6025 16.5069 21.5469 17.6719 21.5469Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.703121 1.85947H3.63528L7.02985 13.7428L6.7636 14.2753C6.06254 15.6759 7.08024 17.3281 8.6505 17.3281H20.4843C20.8729 17.3281 21.1874 17.0137 21.1874 16.625C21.1874 16.2364 20.8729 15.9219 20.4843 15.9219H8.6505C8.12836 15.9219 7.78711 15.3721 8.02153 14.9043L8.21587 14.5157H20.4843C20.798 14.5157 21.0741 14.3076 21.1606 14.0055L23.9731 4.16177C24.0335 3.94962 23.991 3.72162 23.8584 3.54518C23.7252 3.3694 23.5172 3.26572 23.2968 3.26572H5.49948L4.84169 0.963371C4.75516 0.661263 4.47916 0.453186 4.16533 0.453186H0.703121C0.314483 0.453186 0 0.767669 0 1.15631C0 1.54495 0.314483 1.85947 0.703121 1.85947Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.a3028e172566ce360ec14a4fc4b12d5d.svg";
export { ForwardRef as ReactComponent };